import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  getApContollerStateList(params) {
    return axios.post(`${baseUrl}/performance/analysis/ap-controller/get-ap-contoller-state-list.do`, params);
  },
  getCurrentWirelessApInfoByController(params) {
    return axios.post(`${baseUrl}/performance/analysis/ap-controller/get-current-wireless-ap-info-by-controller.do`, params);
  },
  getCurrentRougeApInfoByController(params) {
    return axios.post(`${baseUrl}/performance/analysis/ap-controller/get-current-rouge-ap-info-by-controller.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/performance/ap-controller/controller-info.js